/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Content_Tree_TitleInputs */

const en_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early access to new tree species and sounds`)
};

const ar_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصول مبكر إلى أنواع جديدة من الأشجار والأصوات`)
};

const de_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Früher Zugang zu neuen Baumarten und Sounds`)
};

const es_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso anticipado a nuevas especies de árboles y sonidos`)
};

const fr_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès anticipé à de nouvelles espèces d’arbres et à de nouveaux sons`)
};

const it_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso anticipato a nuove specie di alberi e suoni`)
};

const ja_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい樹種やサウンドへの早期アクセス`)
};

const ko_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로운 나무와 사운드에 얼리 액세스`)
};

const pt_br_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso antecipado a novos sons e espécies de árvore`)
};

const ru_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранний доступ к новым видам деревьев и звукам`)
};

const th_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าถึงพันธุ์ต้นไม้และเสียงใหม่ ๆ ก่อนใคร`)
};

const tr_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni ağaç türlerine ve seslere erken erişim`)
};

const zh_cn_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抢先体验新树种和声音`)
};

const zh_tw_subscription_exclusive_content_tree_title = /** @type {(inputs: Subscription_Exclusive_Content_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搶先體驗新樹種和聲音`)
};

/**
* | output |
* | --- |
* | "Early access to new tree species and sounds" |
*
* @param {Subscription_Exclusive_Content_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_content_tree_title = /** @type {((inputs?: Subscription_Exclusive_Content_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Content_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_content_tree_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_content_tree_title(inputs)
	if (locale === "de") return de_subscription_exclusive_content_tree_title(inputs)
	if (locale === "es") return es_subscription_exclusive_content_tree_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_content_tree_title(inputs)
	if (locale === "it") return it_subscription_exclusive_content_tree_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_content_tree_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_content_tree_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_content_tree_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_content_tree_title(inputs)
	if (locale === "th") return th_subscription_exclusive_content_tree_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_content_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_content_tree_title(inputs)
	return zh_tw_subscription_exclusive_content_tree_title(inputs)
});